import { render, staticRenderFns } from "./userDetailSeckillOrders.vue?vue&type=template&id=1982fdb3&scoped=true"
import script from "./userDetailSeckillOrders.vue?vue&type=script&lang=js"
export * from "./userDetailSeckillOrders.vue?vue&type=script&lang=js"
import style0 from "./userDetailSeckillOrders.vue?vue&type=style&index=0&id=1982fdb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982fdb3",
  null
  
)

export default component.exports